"use client";

import { useEffect, useState } from "react";
import { ScoreStamp } from "@/components/ui/ScoreStamp";
import { scoreBand } from "@/lib/scorecard";

interface MobileVerdictBarProps {
  rating: number;
  albumTitle: string;
  artist: string;
}

export function MobileVerdictBar({ rating, albumTitle, artist }: MobileVerdictBarProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Render always in DOM for SSR/Googlebot; use CSS to toggle visibility
  return (
    <div
      className={`fixed bottom-14 left-0 right-0 z-40 transition-opacity duration-200 sm:hidden ${
        visible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
      aria-hidden={!visible}
    >
      <div className="mx-3 flex items-center gap-3 border border-white/10 bg-[#0d0c0a]/95 px-3 py-2 shadow-[var(--shadow-elevated)] backdrop-blur">
        <ScoreStamp rating={rating} size="xs" />

        {/* Album info */}
        <div className="min-w-0 flex-1">
          <p className="truncate text-[12px] font-semibold text-white">
            {albumTitle}
          </p>
          <p className="truncate text-[10px] text-white/50">
            {artist} &middot; {scoreBand(rating).label}
          </p>
        </div>
      </div>
    </div>
  );
}
